export class DataCatalogGlueProperties {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "awsAccountId",
            "baseName": "awsAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "catalogOwner",
            "baseName": "catalogOwner",
            "type": "CatalogOwner",
            "format": ""
        },
        {
            "name": "databasePrefix",
            "baseName": "databasePrefix",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DataCatalogGlueProperties.attributeTypeMap;
    }
    constructor() {
    }
}
